import React from 'react';
import MoneyAnimation from './MoneyAnimation';
import '../styles/LoadingOverlay.css';

interface LoadingOverlayProps {
  show: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show, message = 'Aguarde, estamos gerando a melhor experiência para você...' }) => {
  if (!show) return null;

  return (
    <div className="loading-overlay">
      <MoneyAnimation />
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingOverlay;
